var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCgtraderLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02939f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399305,
    stopColor: "#19bcc9"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 11.4286,
    x2: -1.30054,
    xlinkHref: "#a",
    y1: 10.2126,
    y2: 29.8699
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 41.4286,
    x2: 28.6995,
    xlinkHref: "#a",
    y1: 10.2126,
    y2: 29.8699
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37.1362 30.2773c.2666-.1512.4822-.3674.6313-.622l-5.7675-3.2723-12 6.8085v6.5502c.2935 0 .587-.0748.8505-.2243z",
    fill: "#04abb8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.1494 39.5174c.2635.1495.557.2243.8505.2243v-6.5502l-11.99996-6.8085-5.76752 3.2723c.14914.2546.36475.4708.63128.622z",
    fill: "#19bcc9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m2.23248 29.6554c-.14974-.2556-.23248-.5499-.23248-.8559v-17.5989c0-.306.08274-.6003.23248-.8559l5.76752 3.2724v12.7659z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m7.99994 13.617 16.95806-9.62163c.4607-.26138.4607-.92091 0-1.18229l-4.1085-2.331086c-.5268-.298479-1.1734-.298298-1.7001.000543l-16.2857 9.240123c-.26653.15122-.48214.36744-.63128.62194z",
    fill: "#19bcc9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m37.7675 10.3447-5.7675 3.2724v12.7659l5.7675 3.2724c.1498-.2556.2325-.5499.2325-.8559v-17.5989c0-.306-.0827-.6003-.2325-.8559z",
    fill: "url(#c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m37.7674 10.3446c-.1488-.254-.3638-.46981-.6296-.62098l-4.2883-2.43312-.0047-.00263c-.526-.29585-1.1702-.29479-1.6954.00317l-16.1076 9.13906c-.4607.2614-.4607.9209 0 1.1823l4.124 2.3399c.5193.2871 1.1515.2867 1.6704-.0013z",
    fill: "#19bcc9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCgtraderLogo);
export default __webpack_public_path__ + "static/media/cgtrader-logo.0a58657ce71955e0a50d95265f585912.svg";
export { ForwardRef as ReactComponent };